'use client';

import {usePathname} from 'next/navigation';
import {SubscriptionPlanProductType, SubscriptionPlansProvider} from '@udemy-v2/subscription-graphql';

import {Header as TeamPlanHeader} from '@/components/header/team-plan-header/team-plan';
import {Footer as TeamPlanFooter} from '@/components/footer/team-plan-footer/team-plan';
import {ToasterProvider} from '@/components/toaster-provider/toaster-provider';
import {TeamPlanSaleBanner} from '@/features/organization-team-plan/components/team-plan-sale-banner';

/** Shared shell for team plan signup flows (buy now and free trial). */
export default function TeamPlanSignupLayout({children}: {children: React.ReactNode}) {
    const pathname = usePathname();
    const buyNow = pathname.includes('/buy-team-plan');

    return (
        <SubscriptionPlansProvider
            subscriptionPlanQueryVariables={[{filters: {productType: SubscriptionPlanProductType.Team}}]}
        >
            <TeamPlanHeader />
            <TeamPlanSaleBanner buyNow={buyNow} />
            {children}
            <TeamPlanFooter />
            <ToasterProvider />
        </SubscriptionPlansProvider>
    );
}
